import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';
import { TableRow, TableCell, Box, TableHead, TableBody, IconButton } from '@material-ui/core';
import { TableLayout } from '../../../containers/Layout';
import { CheckBoxOutlineBlank, CheckBox } from '@material-ui/icons';
import PopUp from '../../../../../../commonModules/interface/PopUp';
import Currency from '../../../../../../commonModules/Currency';
import { useDispatch } from 'react-redux';
import { fetchTransferDetails } from '../../../../../../../../../jsx/actions/transferAction';

const ChooseReturnProduct = ({ return_list, setReturnList, PRODUCTS, return_sale_info, next, previous }) => {
    const dispatch = useDispatch();
    const [trsf, setTrsf] = useState({});

    useEffect(() => {
        const fetchTransferData = async () => {
            try {
                const data = await dispatch(fetchTransferDetails(return_sale_info.id));
                setTrsf(data);
            } catch (error) {
                console.error('Error fetching transfer details:', error);
            }
        };
    
        fetchTransferData();
    }, [dispatch, return_sale_info.id]);

    const handleCheck = (saleItem) => {
        const objList = { ...return_list };
        if (objList[saleItem.id]) {
            delete objList[saleItem.id];
        } else {
            objList[saleItem.id] = saleItem;
        }
        setReturnList(objList);
    };

  const createProductList = () => {
        return trsf.products.map((saleItem, i) => {
            const prod = PRODUCTS[saleItem.product_id];
            
            const ssTt = parseFloat(saleItem.total_ttc);
            let ssTtBase = parseFloat(prod.prix_venteTTC * saleItem.quantity);

            if (ssTt > ssTtBase) {
                ssTtBase = ssTt;
            }

            const isSelected = return_list[saleItem.id];
            console.log('====================================');
            console.log({isSelected});
            console.log('====================================');
            return (
                <TableRow key={i}>
                    <TableCell>{prod.name} - {prod.marque}</TableCell>
                    <TableCell>
                        <b>{saleItem.rest_to_return}</b> / {saleItem.quantity}
                    </TableCell>
                    <TableCell>
                        <Currency value={ssTt} />
                    </TableCell>
                    <TableCell>
                        <IconButton color="secondary" disabled={saleItem.rest_to_return < 1} onClick={() => handleCheck(saleItem)}>
                            {isSelected ? <CheckBox /> : <CheckBoxOutlineBlank />}
                        </IconButton>
                    </TableCell>
                </TableRow>
            );
        });
  };

    return (
        <PopUp
            title={'Produits à retourner'}
            submitAction={next}
            submitTitle="Suivant"
            cancelTitle="Précédent"
            close={previous}
        >
            <Box p={2}>
                {!isEmpty(trsf) && (
                    <div>
                        <TableLayout>
                            <TableHead>
                                <TableRow>
                                    <TableCell colSpan={4} component="th">
                                        Sélectionner les produits à retourner
                                    </TableCell>
                                    </TableRow>
                                    <TableRow>
                                    <TableCell>Produit</TableCell>
                                    <TableCell>Quantité Disponible</TableCell>
                                    <TableCell>Total TTC</TableCell>
                                    <TableCell>Retour</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {createProductList()}
                                <TableRow>
                                    <TableCell colSpan={4}></TableCell>
                                </TableRow>
                            </TableBody>
                        </TableLayout>
                    </div>
                )}
            </Box>
        </PopUp>
    );
};

export default ChooseReturnProduct;
